import { useOidcUser } from '@axa-fr/react-oidc'
import { ButtonComponent } from '@syncfusion/ej2-react-buttons'
import { AppBarComponent } from '@syncfusion/ej2-react-navigations'
import { OidcUserExtendedInfo } from '../../types/OidcUserExtendedInfo.tsx'
import { TooltipComponent } from '@syncfusion/ej2-react-popups'
import { triggerAction } from '../../redux/sideBarSlice.tsx'
import { useAppDispatch, useAppSelector } from '../../hooks/reduxHooks.tsx'
import { FC } from 'react'
import { enableRipple } from '@syncfusion/ej2-base'

type headerProps = {
  logout: () => void
  login: () => void
  isAuthenticated: boolean
}

export const Header: FC<headerProps> = ({ logout, login, isAuthenticated }) => {
  const { oidcUser } = useOidcUser<OidcUserExtendedInfo>()

  const dispatch = useAppDispatch()
  const menuStatus = useAppSelector((state) => state.sideBar.isToggled)

  enableRipple(false)

  return (
    <div className="appHeader">
      <AppBarComponent colorMode={'Dark'}>
        <div>
          <div style={{ width: '40px', display: 'flex', justifyContent: 'center' }}>
            <TooltipComponent position="BottomCenter" content="Menü öffnen/schließen">
              <ButtonComponent style={{ padding: 0 }} id="navToggleBtn" cssClass="e-inherit menu" iconCss="e-icons e-menu" onClick={() => dispatch(triggerAction(!menuStatus))}></ButtonComponent>
            </TooltipComponent>
          </div>
          <span>
            <a href="https://www.kbw.de" style={{ textDecoration: 'none', color: 'white' }}>
              Kommunales Bildungswerk e.V.
            </a>
          </span>
        </div>
        <div className="e-appbar-spacer"></div>
        {oidcUser && (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ marginRight: '5px' }}>Benutzername:</div>
            <div style={{ marginRight: '25px' }}> {oidcUser.name}</div>
          </div>
        )}
        {isAuthenticated ? (
          <ButtonComponent cssClass="e-inherit navBtn" onClick={() => logout()}>
            Logout
          </ButtonComponent>
        ) : (
          <ButtonComponent cssClass="e-inherit navBtn" onClick={() => login()}>
            Login
          </ButtonComponent>
        )}
      </AppBarComponent>
    </div>
  )
}
